import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ASSET_PATHS } from '@app/constants/asset-paths';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent implements OnInit {
  readonly icons = ASSET_PATHS.icons.compliance;

  constructor() { }

  ngOnInit(): void {
  }
}
